import React, { Component } from "react";

// Components
import DragHandle from "../../../utils/sortable/DragHandle";
import SvgIcon from "../../../utils/SvgIcon";

export default class ReviewDocItem extends Component {
	render() {
		const { file, fileParentItem, i } = this.props;

		return (
			<div
				className={
					`document-group--row document-group--edit-row` +
					(file.successful ? ` successful-row` : ``)
				}
			>
				<DragHandle />
				<a className="file-type" href={file.url} target="_blank" rel="noopener noreferrer">
					<SvgIcon type={file.type} />
				</a>
				<div className="file-title">
					<input
						className="blended-input"
						type="text"
						value={file.title}
						onChange={e => this.props.updateFileTitle(e, file.id, fileParentItem)}
						onKeyPress={e => !!file.titleChanged && this.props.handleKeyPressFile(e, i)}
						disabled={!!file.saving}
					/>
				</div>
				<button
					className={`file-save-btn` + (file.titleChanged ? ` shown` : ``)}
					disabled={!!file.saving}
					onClick={() => this.props.saveFileTitle({ fileParentItem, fileIndex: i })}
					title="Save"
				>
					<span className={!!file.saving ? "loading icon-spinner" : "icon-checkmark"} />
				</button>
				<button
					className="file-delete-btn"
					disabled={!!file.saving}
					onClick={() => this.props.deleteFile(file)}
					title="Delete"
				>
					<span className={!!file.deleting ? "loading icon-spinner" : "icon-cross"} />
				</button>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/admin/reviews/form-components/ReviewDocItem.js